// Central site-level constants (author photo, contact info).
// Images are served from the app's own object storage (same-origin /api/files) for reliability.
export const AUTHOR_PHOTO = "/api/files/digsby-early-learning/assets/author.png";

export const CONTACT_EMAIL = "info@digsbyearlylearning.com";

export const LOGO_URL = "/api/files/digsby-early-learning/assets/del-logo.png";

export const SOCIAL = {
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
};
